import React from 'react';
import PropTypes from 'prop-types';
import { Skeleton } from '@material-ui/lab';

import ErrorImage from '../../../../assets/buu.jpg';
import { useProductImageStyles } from './styles';
import { simpleUrl } from '../../../../config/paths';

const ProductImage = ({ ...props }) => {
  const { src, mobile, purchaseState, sku } = props;
  const classes = useProductImageStyles({ mobile, purchaseState });

  return (
    <React.Fragment>
      {!src && src !== 'error' && <Skeleton className={classes.skeleton} />}
      {src && src !== 'error' && (
        <img
          data-cy="productImage"
          className={classes.image}
          src={src}
          onClick={() => sku && window.open(`${simpleUrl}${sku}`, '_blank')}
        />
      )}
      {src && src === 'error' && (
        <img data-cy="errorImage" className={classes.image} src={ErrorImage} />
      )}
    </React.Fragment>
  );
};

ProductImage.propTypes = {
  src: PropTypes.string,
  mobile: PropTypes.bool,
  purchaseState: PropTypes.string,
  sku: PropTypes.string,
};

export default ProductImage;
